import jQuery from "jquery";
(function ($) {
  "use strict";

  // Spinner
  var spinner = function () {
    setTimeout(function () {
      if ($("#spinner").length > 0) {
        $("#spinner").removeClass("show");
      }
    }, 1);
  };
  spinner(0);

  // Sticky Navbar
  $(window).scroll(function () {
    if ($(this).scrollTop() > 45) {
      $(".navbar").addClass("sticky-top shadow-sm");
    } else {
      $(".navbar").removeClass("sticky-top shadow-sm");
    }
  });

  // International Tour carousel
  // $(".InternationalTour-carousel").owlCarousel({
  //     autoplay: true,
  //     smartSpeed: 1000,
  //     center: false,
  //     dots: true,
  //     loop: true,
  //     margin: 25,
  //     nav: false,
  //     navText: [
  //         '<i class="bi bi-arrow-left"></i>',
  //         '<i class="bi bi-arrow-right"></i>'
  //     ],
  //     responsiveClass: true,
  //     responsive: {
  //         0: {
  //             items: 1
  //         },
  //         768: {
  //             items: 2
  //         },
  //         992: {
  //             items: 2
  //         },
  //         1200: {
  //             items: 3
  //         }
  //     }
  // });

  // // packages carousel
  // $(".packages-carousel").owlCarousel({
  //     autoplay: true,
  //     smartSpeed: 1000,
  //     center: false,
  //     dots: false,
  //     loop: true,
  //     margin: 25,
  //     nav: true,
  //     navText: [
  //         '<i class="bi bi-arrow-left"></i>',
  //         '<i class="bi bi-arrow-right"></i>'
  //     ],
  //     responsiveClass: true,
  //     responsive: {
  //         0: {
  //             items: 1
  //         },
  //         768: {
  //             items: 2
  //         },
  //         992: {
  //             items: 2
  //         },
  //         1200: {
  //             items: 3
  //         }
  //     }
  // });

  // // testimonial carousel
  // $(".testimonial-carousel").owlCarousel({
  //     autoplay: true,
  //     smartSpeed: 1000,
  //     center: true,
  //     dots: true,
  //     loop: true,
  //     margin: 25,
  //     nav: true,
  //     navText: [
  //         '<i class="bi bi-arrow-left"></i>',
  //         '<i class="bi bi-arrow-right"></i>'
  //     ],
  //     responsiveClass: true,
  //     responsive: {
  //         0: {
  //             items: 1
  //         },
  //         768: {
  //             items: 2
  //         },
  //         992: {
  //             items: 2
  //         },
  //         1200: {
  //             items: 3
  //         }
  //     }
  // });

  // Back to top button
  document.addEventListener("DOMContentLoaded", function () {
    const backToTopButton = document.querySelector(".back-to-top");
    if (backToTopButton) {
      // Check if the element exists
      window.addEventListener("scroll", function () {
        if (window.scrollY > 300) {
          backToTopButton.classList.add("show");
        } else {
          backToTopButton.classList.remove("show");
        }
      });

      backToTopButton.addEventListener("click", function (e) {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    }
  });

  

})(jQuery);
